import { FC, useContext } from 'react';
import logo from '../assets/logos/logo.jpg';
import AuthContext from '../contexts/authContext';

interface ILogoProps {
	width?: number;
	height?: number;
}
const Logo: FC<ILogoProps> = ({ width, height }) => {

	const { configData } = useContext(AuthContext);

	let apiBaseURL = configData.find((item: any) => item.configName === 'API_BASE_PATH')?.configValue;
	let logoPath = configData.find((item: any) => item.configName === 'LOGO_PATH')?.configValue;
	let logoURL = `${apiBaseURL}${logoPath}`;

	return (
		<img
			src={logoURL}
			width={width}
			height={height}
			style={{ color: 'maroon' }}
		/>
	);
};

export default Logo;
